module.exports = __webpack_public_path__ + "static/media/158-egypt.009b9dc9.svg";